import axios from 'axios';

const ROLES_REQUIRING_PHONE = [60, 70];

function hasPhone(addressBook) {
  if (!addressBook || typeof addressBook !== 'object') return false;
  const primary = (addressBook.phone_primary || '').trim();
  return primary.length > 0;
}

// Resolves where to send the user after login. For roles 60/70 with no phone
// on file, returns '/extprofile?phonerequired=1' (and stashes the original
// destination in redirectAfterLogin so Profile.vue can hand back control once
// they save). Falls back to redirectAfterLogin or '/' otherwise.
export async function resolvePostLoginPath(userId) {
  let originalPath = '/';
  const stored = localStorage.getItem('redirectAfterLogin');
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      originalPath = parsed.path || '/';
    } catch (e) {
      // ignore malformed value
    }
  }

  try {
    const [roleRes, abRes] = await Promise.all([
      axios.get(`user/role/${userId}`),
      axios.post('requesters/getuser', { id: userId }),
    ]);

    const roles = (roleRes && roleRes.data && roleRes.data.roles) || [];
    const needsPhone = roles.some(r => ROLES_REQUIRING_PHONE.includes(Number(r)));
    if (!needsPhone) {
      localStorage.removeItem('redirectAfterLogin');
      return originalPath;
    }

    const ab = abRes && typeof abRes.data === 'object' ? abRes.data : null;
    if (hasPhone(ab)) {
      localStorage.removeItem('redirectAfterLogin');
      return originalPath;
    }

    // Keep redirectAfterLogin so Profile.vue can route back after save.
    if (originalPath && originalPath !== '/extprofile') {
      localStorage.setItem('redirectAfterLogin', JSON.stringify({ path: originalPath }));
    }
    return '/extprofile?phonerequired=1';
  } catch (e) {
    console.error('postLoginRedirect: role/addressbook lookup failed', e);
    localStorage.removeItem('redirectAfterLogin');
    return originalPath;
  }
}
